module.exports = __webpack_public_path__ + "assets/responsive.09fa58cd134b881a639bbf693c4f5b1e.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/responsive.png
// module id = 881
// module chunks = 0